import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "./firestore";

const validDate = (value) => typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) &&
  Number.isFinite(Date.parse(`${value}T00:00:00Z`)) && new Date(`${value}T00:00:00Z`).toISOString().slice(0, 10) === value;
const personName = (value) => typeof value === "string" && value.length <= 120 ? value.trim() : "";

// Read only the public projection. Canonical stock, processing sources and
// package definitions contain private information and are never queried here.
export function publicProcessedBatches(records, product, now = Date.now()) {
  const today = new Intl.DateTimeFormat("sv-SE", {
    timeZone: "Europe/Stockholm", year: "numeric", month: "2-digit", day: "2-digit",
  }).format(new Date(now));
  return records.filter((record) => record.isPublic === true &&
    record.productDocId === product.firebaseId && record.productId === product.id &&
    validDate(record.processDate) && validDate(record.packingDate) &&
    record.processDate <= record.packingDate && record.packingDate <= today &&
    (record.bestBeforeDate === undefined || record.bestBeforeDate === "" || (validDate(record.bestBeforeDate) && record.packingDate <= record.bestBeforeDate))
  ).map((record) => ({
    // Explicitly select customer fields, even for historical projection records.
    processDate: record.processDate, processedBy: personName(record.processedBy),
    packingDate: record.packingDate, packedBy: personName(record.packedBy),
    bestBeforeDate: record.bestBeforeDate || "",
    batchLabel: record.packingDate.slice(2).replace(/-/g, ""),
  })).sort((a, b) => b.packingDate.localeCompare(a.packingDate) || a.processDate.localeCompare(b.processDate));
}

export async function getProcessedProductTrace(product) {
  const identity = { firebaseId: product.firebaseId, id: typeof product.id === "string" && product.id.trim() ? product.id : product.firebaseId };
  if (!identity.firebaseId) return [];
  // All three constraints are required by the public trace read rule. Product
  // document IDs and the business IDs saved on stock are not interchangeable.
  const snapshot = await getDocs(query(collection(db, "products_freezedry_package_batch"),
    where("isPublic", "==", true), where("productDocId", "==", identity.firebaseId), where("productId", "==", identity.id)));
  return publicProcessedBatches(snapshot.docs.map((document) => document.data()), identity);
}
